import { render, staticRenderFns } from "./chose_spec.vue?vue&type=template&id=66eba35c&scoped=true&"
import script from "./chose_spec.vue?vue&type=script&lang=js&"
export * from "./chose_spec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eba35c",
  null
  
)

export default component.exports